import { render, staticRenderFns } from "./TrailerModal.vue?vue&type=template&id=0ac4641c&scoped=true"
import script from "./TrailerModal.vue?vue&type=script&lang=js"
export * from "./TrailerModal.vue?vue&type=script&lang=js"
import style0 from "./TrailerModal.vue?vue&type=style&index=0&id=0ac4641c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac4641c",
  null
  
)

export default component.exports